import * as React from 'react';
import styles from '~/CzReimbursement/styles.less';
import { DebounceInput } from '~/Debounce';
import Checkbox from '~/UI/Checkbox/Checkbox';
import Icon from '~/UI/Icon';
import { Input } from '~/UI/Input';
import inputCompactStyles from '~/UI/Input/compact.less';

export interface SettingsValues {
	readonly dosageStrength: string;
	readonly packageSize: string;
	readonly selected: boolean;
	readonly usualTherapeuticDailyDose: string;
	readonly usualTherapeuticDailyDosePerPackage: string;
}

export interface SettingsErrors {
	readonly dosageStrength?: boolean;
	readonly packageSize?: boolean;
	readonly usualTherapeuticDailyDose?: boolean;
	readonly usualTherapeuticDailyDosePerPackage?: boolean;
}

export const EmptySettingsVaslues: SettingsValues = {
	dosageStrength: '',
	packageSize: '',
	selected: true,
	usualTherapeuticDailyDose: '',
	usualTherapeuticDailyDosePerPackage: '',
};

const SettingInput: React.FunctionComponent<
	React.PropsWithChildren<{
		label: string;
		showHeader: boolean;
		value: string;
		isInvalid: boolean;
		onChange(value: string): void;
	}>
> = ({ label, showHeader, value, isInvalid, onChange }) => {
	return (
		<div className={showHeader ? styles.groupListInputContainerWithHeader : styles.groupListInputContainer}>
			{showHeader ? <span>{label}</span> : null}
			<DebounceInput value={value} onBlur={() => {}} onChange={onChange}>
				<Input isInvalid={isInvalid} styles={inputCompactStyles} />
			</DebounceInput>
		</div>
	);
};

export const Settings: React.FunctionComponent<
	React.PropsWithChildren<{
		errors: SettingsErrors;
		showHeader: boolean;
		usedForCalculation: boolean;
		values: SettingsValues;
		onChange(values: SettingsValues): void;
	}>
> = ({ errors, showHeader, usedForCalculation, values, onChange }) => {
	return (
		<>
			{usedForCalculation ? (
				<div className={styles.listFormulaIconContainer} title='Used for calculation'>
					<Icon name='formula' />
				</div>
			) : null}

			<SettingInput
				isInvalid={errors.packageSize ?? false}
				label='Package'
				showHeader={showHeader}
				value={values.packageSize}
				onChange={(packageSize) => {
					onChange({ ...values, packageSize });
				}}
			/>

			<SettingInput
				isInvalid={errors.dosageStrength ?? false}
				label='Dosage'
				showHeader={showHeader}
				value={values.dosageStrength}
				onChange={(dosageStrength) => {
					onChange({ ...values, dosageStrength });
				}}
			/>

			<SettingInput
				isInvalid={errors.usualTherapeuticDailyDose ?? false}
				label='ODTD'
				showHeader={showHeader}
				value={values.usualTherapeuticDailyDose}
				onChange={(usualTherapeuticDailyDose) => {
					onChange({ ...values, usualTherapeuticDailyDose });
				}}
			/>

			<SettingInput
				isInvalid={errors.usualTherapeuticDailyDosePerPackage ?? false}
				label='ODTDBAL'
				showHeader={showHeader}
				value={values.usualTherapeuticDailyDosePerPackage}
				onChange={(usualTherapeuticDailyDosePerPackage) => {
					onChange({ ...values, usualTherapeuticDailyDosePerPackage });
				}}
			/>

			<Checkbox
				checked={values.selected}
				onChange={(selected) => {
					onChange({ ...values, selected });
				}}
			/>
		</>
	);
};

Settings.displayName = 'CzReimbursement.GroupList.Settings';
